//https://statisticstimes.com/geography/countries-by-continents.php
//Using ISO-3
export const europe = [
  "ALA",
  "ALB",
  "AND",
  "AUT",
  "BLR",
  "BEL",
  "BIH",
  "BGR",
  "HRV",
  "CZE",
  "DNK",
  "EST",
  "FRO",
  "FIN",
  "FRA",
  "DEU",
  "GIB",
  "GRC",
  "GGY",
  "VAT",
  "HUN",
  "ISL",
  "IRL",
  "ITA",
  "JEY",
  "LVA",
  "LIE",
  "LTU",
  "LUX",
  "MLT",
  "MCO",
  "MNE",
  "NLD",
  "MKD",
  "NOR",
  "POL",
  "PRT",
  "MDA",
  "ROU",
  "RUS",
  "SMR",
  "SRB",
  "SVK",
  "SVN",
  "ESP",
  "SJM",
  "SWE",
  "CHE",
  "UKR",
  "GBR",
];
export const asia = [
  "AFG",
  "ARM",
  "AZE",
  "BHR",
  "BGD",
  "BTN",
  "BRN",
  "KHM",
  "CHN",
  "HKG",
  "MAC",
  "CYP",
  "PRK",
  "GEO",
  "IND",
  "IDN",
  "IRN",
  "IRQ",
  "ISR",
  "JPN",
  "JOR",
  "KAZ",
  "KWT",
  "KGZ",
  "LAO",
  "LBN",
  "MYS",
  "MDV",
  "MNG",
  "MMR",
  "NPL",
  "OMN",
  "PAK",
  "PHL",
  "QAT",
  "KOR",
  "SAU",
  "SGP",
  "LKA",
  "PSE",
  "SYR",
  "TJK",
  "THA",
  "TLS",
  "TUR",
  "TKM",
  "ARE",
  "UZB",
  "VNM",
  "YEM",
];

export const america = [
  "AIA",
  "ATG",
  "ABW",
  "BHS",
  "BRB",
  "BLZ",
  "BMU",
  "BES",
  "VGB",
  "CAN",
  "CYM",
  "CRI",
  "CUB",
  "CUW",
  "DMA",
  "DOM",
  "SLV",
  "GRL",
  "GRD",
  "GLP",
  "GTM",
  "HTI",
  "HND",
  "JAM",
  "MTQ",
  "MEX",
  "MSR",
  "NIC",
  "PAN",
  "PRI",
  "BLM",
  "KNA",
  "LCA",
  "MAF",
  "SPM",
  "VCT",
  "SXM",
  "TTO",
  "TCA",
  "USA",
  "VIR",
  "ARG",
  "BOL",
  "BVT",
  "BRA",
  "CHL",
  "COL",
  "ECU",
  "FLK",
  "GUF",
  "GUY",
  "PRY",
  "PER",
  "SGS",
  "SUR",
  "URY",
  "VEN",
];

export const oceania = ["ASM", "AUS", "CXR", "CCK", "COK", "FJI", "PYF", "GUM", "HMD", "KIR", "MHL", "FSM", "NRU", "NCL", "NZL", "NIU", "NFK", "MNP", "PLW", "PNG", "PCN", "WSM", "SLB", "TKL", "TON", "TUV", "UMI", "VUT", "WLF"];

export const africa = [
  "DZA",
  "AGO",
  "BEN",
  "BWA",
  "IOT",
  "BFA",
  "BDI",
  "CPV",
  "CMR",
  "CAF",
  "TCD",
  "COM",
  "COG",
  "CIV",
  "COD",
  "DJI",
  "EGY",
  "GNQ",
  "ERI",
  "SWZ",
  "ETH",
  "ATF",
  "GAB",
  "GMB",
  "GHA",
  "GIN",
  "GNB",
  "KEN",
  "LSO",
  "LBR",
  "LBY",
  "MDG",
  "MWI",
  "MLI",
  "MRT",
  "MUS",
  "MYT",
  "MAR",
  "MOZ",
  "NAM",
  "NER",
  "NGA",
  "REU",
  "RWA",
  "SHN",
  "STP",
  "SEN",
  "SYC",
  "SLE",
  "SOM",
  "ZAF",
  "SSD",
  "SDN",
  "TGO",
  "TUN",
  "UGA",
  "TZA",
  "ESH",
  "ZMB",
  "ZWE",
];
